export default {"src":"/uk/_next/static/media/spot-diverse-portfolio.650876be.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};